// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jp-0";